import React from 'react'

import ProjectInvoiceListItem from './ProjectInvoiceListItem'

const ProjectInvoiceList = (props) => {
    return (

        <div className="d-flex flex-column">
            {
                props.invoices.map((invoice, index) => <ProjectInvoiceListItem canDownload={props.canDownload}
                                                                               canRemove={props.canRemove}
                                                                               canEdit={props.canEdit}
                                                                               project_id={props.project_id} key={index}
                                                                               onEdit={(invoiceID) => {
                                                                                if(props.onEdit) props.onEdit(invoiceID)
                                                                               }}
                                                                               onAddCreditNote={(invoiceID) => {
                                                                                    props.onAddCreditNote(invoiceID)
                                                                               }}
                                                                               invoice={invoice}/>)
            }
        </div>


    )
}

export default ProjectInvoiceList